export const settingUserCreationSteps = [
   {
    target: ".j_st_usCr",
    content:
      "You're on the 'User Creation Flow' tab. This is where you configure the step-by-step workflow for how new users are onboarded into the system.",
    placement: "bottom",
  },
  {
    target: ".j_st_usCr",
    content:
      "You're on the 'User Creation Flow' tab. This is where you configure the step-by-step workflow for how new users are onboarded into the system.",
    placement: "bottom",
  },
  {
    target: ".j_st_usCr_f",
    content:
      "Choose a predefined flow from the list here (Flow 101, Flow 1, etc.). Each one defines a unique sequence of approvals and actions.",
    placement: "bottom",
  },

  {
    target: ".j_f_btn_ac",
    content:
      "Click this to activate the currently selected flow. Only one flow can be active at a time — it determines how all new users will be processed.",
    placement: "bottom",
  },
  {
    target: ".j_f_at_step",
    content:
      "This section shows the individual steps in the flow — like request submission, optional manager approval, and final admin creation. Each step can be independently configured.",
    placement: "bottom",
  },
   {
    target: ".j_f_st_req",
    content:
      "This is the Requester step — typically the first in the flow. The person initiating the user creation request fills in basic user details and submits the request.",
    placement: "bottom",
  },

  {
    target: ".j_st_email",
    content:
      "Enable or disable email notifications per step. If enabled, selected stakeholders will receive notifications when that step is executed.",
    placement: "bottom",
  },
  {
    target: ".j_st_hld",
    content:
      "Select which stakeholders should receive emails for this step — e.g., Admin, Receiver, or Sender.",
    placement: "bottom",
  },
    {
    target: ".j_st_mngr",
    content:
      "This optional step involves the Manager reviewing and either approving or rejecting the request. You can configure whether this step is mandatory.",
    placement: "bottom",
  },
  {
    target: ".j_st_admin",
    content:
      "The Admin step is the final step in the flow. The admin reviews all previous steps and formally creates the user in the system. This step is mandatory.",
    placement: "bottom",
  },
  {
    target: ".j_st_svBtn",
    content:
      "Click 'Save' to apply your changes. This will update the active flow and its configurations.",
    placement: "left",
  },
  {
    target: ".j_st_rstBtn",
    content:
      "Click 'Reset' to discard all unsaved changes and restore the last saved version of this flow.",
    placement: "left",
  },
  {
    target: ".j_st_dim",
    content:
      "This tab lets you define key system dimensions — like departments, business units, or access scopes.",
    placement: "bottom",
  },
  {
    target: ".j_st_adCnfig",
    content:
      "In the 'AD Config' tab, you can link and sync your system with Active Directory — manage groups, user syncing, and credentials.",
    placement: "bottom",
  },
  {
    target: ".j_st_eCnfig",
    content:
      "Use this tab to configure how the system sends emails — define SMTP details, sender info, and notification toggles.",
    placement: "bottom",
  },
  {
    target: ".j_st_etmp",
    content:
      "Customize the content and design of system emails here — modify templates for different actions like approvals and notifications.",
    placement: "bottom",
  },
  {
    target: ".j_st_other",
    content:
      "The 'Other' tab holds advanced or miscellaneous configuration options that don't fall under the main categories.",
    placement: "bottom",
  },
];

export const settingDimensionSteps = [
  {
    target: '.j_st_dim',
    content: "This tab lets you define key system dimensions — like departments, business units, or access scopes.",
    placement: 'bottom',
  },
  {
    target: '.j_st_d_dimCol',
    content: 'Define the dimension fields by clicking on the dimension name.',
    placement: 'bottom',
  },
    {
    target: '.j_st_d_name',
    content: 'Define the name for each dimension here.',
    placement: 'bottom',
  },
    {
    target: '.j_st_d_clr',
    content: 'Define the text colour for each dimension here.',
    placement: 'bottom',
  },
      {
    target: '.j_st_d_bg',
    content: 'Define the background colour for each dimension here.',
    placement: 'bottom',
  },
  {
    target: '.j_st_d_reset',
    content: 'Click here to reset any changes.',
    placement: 'top',
  },
  {
    target: '.j_st_d_save',
    content: 'Click here to save your changes.',
    placement: 'left',
  }
];
export const settinAdConfigSteps = [
  {
    target: '.j_st_adCnfig',
    content: 'This is the AD Config tab where Active Directory settings are managed.',
    placement: 'bottom',
  },
  {
    target: '.j_st_adCo_cId',
    content: 'Enter the Azure AD Client ID here.',
    placement: 'bottom',
  },
  {
    target: '.j_st_adCo_auth',
    content: 'Provide the Authority URL (usually Microsoft login URL).',
    placement: 'bottom',
  },
  {
    target: '.j_st_adCo_uri',
    content: 'Set the Redirect URI for authentication callbacks.',
    placement: 'bottom',
  },
  {
    target: '.j_st_adCo_reset',
    content: 'Click to reset all fields.',
    placement: 'top',
  },
  {
    target: '.j_st_adCo_save',
    content: 'Click to save the AD configuration.',
    placement: 'left',
  }
];
export const settingEmailConfigSteps = [
  {
    target: '.j_st_eCnfig',
    content: 'This is the Email Config tab where you configure SMTP settings for sending emails.',
    placement: 'bottom',
  },
  {
    target: '.j_st_eC_frm',
    content: 'Specify the "From Email Address" used to send emails.',
    placement: 'bottom',
  },
      {
    target: '.j_st_eC_dCred',
    content: 'Enable or disable this if you want to make all the information as default.',
    placement: 'top',
  },
  
    {
    target: '.j_st_eC_ssl',
    content: 'Enable or disable SSL for secure connection.',
    placement: 'top',
  },
  {
    target: '.j_st_eC_unme',
    content: 'Provide the user name for the email account.',
    placement: 'bottom',
  },
  {
    target: '.j_st_eC_pwrd',
    content: 'Enter the password for the email account.',
    placement: 'bottom',
  },
  {
    target: '.j_st_eC_host',
    content: 'Enter the SMTP host, e.g., smtp.gmail.com.',
    placement: 'bottom',
  },
  {
    target: '.j_st_eC_port',
    content: 'Specify the SMTP port, commonly 587 or 465.',
    placement: 'bottom',
  },

  {
    target: '.j_st_eC_rst',
    content: 'Click to reset all email settings.',
    placement: 'top',
  },
  {
    target: '.j_st_eC_save',
    content: 'Click to save the email configuration.',
    placement: 'left',
  }
];
export const settingEmailTempSteps = [
  {
    target: '.j_st_etmp',
    content: 'This panel shows a list of available email templates. Click on any template to edit its content.',
    placement: 'right',
  },
  {
    target: '.j_st_mt_type',
    content: 'These are the present templates for email, the one highlighted in green is the active one.',
    placement: 'right',
  },
  {
    target: '.j_st_mt_lbl',
    content: 'Enter or update the subject line of the selected email template here.',
    placement: 'bottom',
  },
  {
    target: '.j_st_mt_desc',
    content: 'This section provides contextabout the selected template.You can edit the main content of the email here using the rich text editor.',
    placement: 'bottom',
  },

  {
    target: '.j_st_mt_save',
    content: 'Click here to save all the changes you made to the selected email template.',
    placement: 'top',
  },

];
export const settingOtherSteps = [
  {
    target: '.j_st_other',
    content: 'You’re in the "Other" settings tab. It contains general configurations like retry limits and timeout values.',
    placement: 'bottom',
  },
  {
    target: '.j_st_otr_cnt',
    content: 'Set the number of retry attempts the system should make before failing.',
    placement: 'bottom',
  },
  {
    target: '.j_st_otr_tOut',
    content: 'Specify how long (in milliseconds) the system should wait before timing out a request.',
    placement: 'bottom',
  },
  {
    target: '.j_st_otj_r_save',
    content: 'Click here to save the updated values for retry count and timeout settings.',
    placement: 'top',
  },
];

